/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BatchAutocompleteItemSchema } from './batchAutocompleteItemSchema';

export interface BatchAutocompleteRequestSchema {
  /** @maxItems 20 */
  items: BatchAutocompleteItemSchema[];
  pool_ids?: string[] | null;
}
